export default __webpack_public_path__ + "static/media/panelReveal.be7ee530.jpg";